import { useTranslations } from '@vocab/react';
import { Box, List, Stack, Text, TextLink } from 'braid-design-system';

import { useConfig } from 'src/app/shared/hooks/useConfig';
import { getPhoneNumber } from 'src/app/utils/getPhoneNumber';
import { ErrorSectionLayout } from 'src/app/v2/components/ErrorSectionLayout';

import translations from './.vocab';
import { RecoverableErrorSvg } from './RecoverableErrorSvg';

export const ErrorSectionRecoverable = () => {
  const { t } = useTranslations(translations);
  const { getSite } = useConfig();
  const phoneNumber = getPhoneNumber(getSite());

  return (
    <ErrorSectionLayout
      heading={t('error-section-recoverable-heading')}
      image={<RecoverableErrorSvg />}
    >
      <Stack space="large">
        <Text>{t('error-section-recoverable-heading')}</Text>
        <Stack space="small">
          <Text>{t('error-section-recoverable-resolution-label')}</Text>
          <List space="small">
            <Text>{t('error-section-recoverable-resolution-one-text')}</Text>
            <Text>{t('error-section-recoverable-resolution-two-text')}</Text>
          </List>
        </Stack>
        <Box paddingTop="small">
          <Text>
            {t('error-section-recoverable-contact-us-anz', {
              phoneNumber: phoneNumber || '',
              PhoneLink: (tel: React.ReactNode[]) => (
                <TextLink weight="weak" href={`tel:${tel}`}>
                  {tel}
                </TextLink>
              ),
            })}
          </Text>
        </Box>
      </Stack>
    </ErrorSectionLayout>
  );
};
